<div class="new-dataset-container" *ngIf="form" [formGroup]="form">
  <mat-card class="dataset-card">
    <div class="allow-filtering-container">
      @if (allowFiltering) {
        <div class="left-label user-filtering-label">
          <wm-common-text [data]="{ text: 'Filter Input Configuration' }">
          </wm-common-text>
        </div>
      }
      <!-- Start Code added by Sanchit on 04/27/2026 -->
      <!-- <div class="right-section">
        <div class="user-filtering-label">
          <wm-common-text [data]="{ text: 'Allow User Filtering' }">
          </wm-common-text>
        </div>
        <mat-slide-toggle
          [checked]="allowFiltering"
          (change)="allowFilteringChanged.emit($event.checked)">
        </mat-slide-toggle>
      </div> -->
      <div class="toggle-row">
        <input
          type="checkbox"
          class="native-toggle"
          [checked]="allowFiltering"
          (change)="allowFilteringChanged.emit($event.target.checked)"
        />
        
        <wm-common-text [data]="{ text: 'Allow User Filtering' }">
        </wm-common-text>
      </div>
      <!-- End Code added by Sanchit on 04/27/2026 -->
    </div>
    @if (allowFiltering) {
      <div class="filter-table content-center" [class.scrollable]="filterFields?.length > 1">
        <wm-common-table
          *ngIf="filterFields?.length"
          [columns]="filterColumns"
          [data]="filterFields"
          tableType="Staff"
          (iconClick)="handleIconClick($event)">
        </wm-common-table>
        <div class="add-config">
          <a (click)="openFilterInput()">+ Add Input Configuration</a>
        </div>
      </div>
    }
  </mat-card>
</div>

<wm-common-overlay-modal
  *ngIf="showOverlayEditor"
  [bodyPadding]="'0'"
  [isOpen]="showOverlayEditor"
  headerTitle="Filter Input Column Settings"
  maxWidth="1086px"
  minHeight="420px"
  (closed)="close()">
  <div class="inner-container" *ngIf="form" [formGroup]="form">
    <div class="inner">
      <div class="filter-input-settings">
        <div class="filter-input-settings-body">
          <div class="form-field">
            <label class="form-label">Column</label>
            <div class="field-control">
              <!-- Added by amisha on 05/04/2026 so the field-control wrapper owns the effective width,
                   matching the working column-settings overlay behavior. -->
              <!-- Added by Amisha on 09/25/2026. Reason: preserve parent scrolling
                   and close the Column panel when the contained modal/page scrolls. -->
              <wm-common-dropdown
                formControlName="field"
                [data]="{
                  placeholder: 'Column',
                  options: resolvedColumnOptions,
                  lockParentScroll: false,
                  closeOnScroll: true,
                  style: {
                    width: '100%'
                  }
                }">
              </wm-common-dropdown>
            </div>
          </div>

          <div class="form-field">
            <label class="form-label">Label</label>
            <div class="field-control">
              <wm-common-textfield
                formControlName="label"
                [data]="{
                  placeholder: 'Label'
                }">
              </wm-common-textfield>
            </div>
          </div>

          <div class="form-field required-field">
            <label class="form-label">Required</label>
            <!-- Start Code added by Sanchit on 04/27/2026 -->
            <!-- <mat-slide-toggle
              formControlName="isRequired"
              (change)="requiredSliderChanged($event.checked)">
            </mat-slide-toggle> -->
            <label class="toggle-row">
              <input
                type="checkbox"
                class="native-toggle"
                formControlName="isRequired"
                (change)="requiredSliderChanged($event.target.checked)"
              />
              <wm-common-text [data]="{ text: '' }"></wm-common-text>
            </label>
            <!-- End Code added by Sanchit on 04/27/2026 -->
          </div>
        </div>
      </div>

      <div modal-footer class="filter-input-settings-footer">
        <button class="btn-secondary" (click)="close()">
          CANCEL
        </button>
        <button class="btn-primary" (click)="save()">
          SAVE
        </button>
      </div>
    </div>
  </div>
</wm-common-overlay-modal>

<div class="modal-width">
  <wm-common-confirmation-modal
    [data]="deleteConfirmModal"
    (onYesClick)="deleteFilter()"
    (onNoClick)="deleteConfirmModal.open=false"
    (onCloseClick)="deleteConfirmModal.open=false">
  </wm-common-confirmation-modal>
</div>
